import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const pushApi = createApi({
  reducerPath: "pushApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    registerPushToken: builder.mutation({
      query: (data) => ({ url: "/push/register", method: "POST", body: data }),
    }),
    unregisterPushToken: builder.mutation({
      query: (data) => ({ url: "/push/unregister", method: "POST", body: data }),
    }),
  }),
});

export const { useRegisterPushTokenMutation, useUnregisterPushTokenMutation } = pushApi;
